import React from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'

import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'

  // todo i18n: for english users, add &lang=en to iFrame and share.

class ModalPoll extends React.Component {

  render() {
    if(this.props.shouldShow) {
      const {content, type, account_plan} = this.props;
      let iframeHeight = "153"; // 1 = 153px, 2 = 184px, 3 = 215px
      if(content.options.length === 2) {iframeHeight = "184"} else if(content.options.length === 3) {iframeHeight = "215"}
      if(type && type === "qp") iframeHeight = "163";
      if(type && type === "qpm") iframeHeight = "477";
      let poll_url = "poll";
      if(type && type === "qp") poll_url = "quickpoll";
      if(type && type === "qpm") poll_url = "quickpollmedia";

      return (
        <ModalWrapper switchState={this.props.close}>
          <p style={{marginBottom:".5em", textAlign:"left"}}><b style={{fontSize:"120%"}}>{content.name}</b></p>
          {content.options.map(function(item, i) {
          return <div className="card-layout" key={i}>
            <div className="card-layout-div50">{item.label}</div>
            <div className="card-layout-div50" style={{textAlign:"right"}}>({item.votes} {this.props.i18n_texts["gen_votes"][this.props.app_language]}) {(content.vote_count > 0) ? Math.floor(item.votes / content.vote_count * 100): 0}%</div>
          </div>}.bind(this))}
          <div style={{textAlign:"right", marginTop:".3em"}}><small>{this.props.i18n_texts["gen_total_number_of_votes"][this.props.app_language]}: {content.vote_count}</small></div>
          <hr style={{border:"0", margin:"44px 0px 24px"}}/>
          <p style={{fontSize:"90%", marginBottom:"0", display:"inline-block"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["core_polls_view_embed"][this.props.app_language]}}></p>
          <div style={{fontSize:"79%"}}><p className="rfq-description">{this.props.i18n_texts["core_polls_view_embed_description"][this.props.app_language]}</p>
          {(account_plan === "premium" || account_plan === "trial" || (account_plan === "lite" && content.i === 0)) && <pre style={{fontSize:"90%"}}>&lt;iframe src=&quot;https://citrus.polymedia.nl/{poll_url}/{content.ref_id}?embed&quot; height=&quot;{iframeHeight}&quot; style=&quot;border:0;width:100%&quot;&gt;&lt;/iframe&gt;</pre>}
          {(account_plan === "lite" && content.i !== 0 && this.props.app_language === "NL") && <div style={{fontSize:"98%", padding:"14px", backgroundColor:"#f0f0f0"}}><span role="img" aria-label="lock">🔒</span> Jouw plan is gelimiteerd aan één poll, deze content is alleen beschikbaar voor Pro gebruikers. Ga alsjeblieft naar <Link to="/settings">Instellingen</Link> om jouw plan aan te passen.</div>}
          {(account_plan === "lite" && content.i !== 0 && this.props.app_language === "EN") && <div style={{fontSize:"98%", padding:"14px", backgroundColor:"#f0f0f0"}}><span role="img" aria-label="lock">🔒</span> Your plan is limited to one poll, this content is only available for Pro users. Please go to <Link to="/settings">Settings</Link> to change your plan.</div>}
          </div>
          <div style={{fontSize:"90%", borderTop:"1px solid #ddd", margin:"2em 3em", height:"0"}}><span style={{marginTop:"-12px", display:"block", textAlign:"center"}}><span style={{padding:"9px", background:"#fff", color:"#888"}}>{this.props.i18n_texts["core_polls_view_andor"][this.props.app_language]}</span></span></div>
          <p style={{fontSize:"90%", marginBottom:"0", display:"inline-block"}} dangerouslySetInnerHTML={{__html:this.props.i18n_texts["core_polls_view_share"][this.props.app_language]}}></p>
          <div style={{fontSize:"79%"}}><p className="rfq-description">{this.props.i18n_texts["core_polls_view_share_description"][this.props.app_language]}</p>
          {(account_plan === "premium" || account_plan === "trial" || (account_plan === "lite" && content.i === 0)) && <pre style={{fontSize:"90%"}}>https://citrus.polymedia.nl/{poll_url}/{content.ref_id}</pre>}
          {(account_plan === "lite" && content.i !== 0 && this.props.app_language === "NL") && <div style={{fontSize:"98%", padding:"14px", backgroundColor:"#f0f0f0"}}><span role="img" aria-label="lock">🔒</span> Jouw plan is gelimiteerd aan één poll, deze content is alleen beschikbaar voor Pro gebruikers. Ga alsjeblieft naar <Link to="/settings">Instellingen</Link> om jouw plan aan te passen.</div>}
          {(account_plan === "lite" && content.i !== 0 && this.props.app_language === "EN") && <div style={{fontSize:"98%", padding:"14px", backgroundColor:"#f0f0f0"}}><span role="img" aria-label="lock">🔒</span> Your plan is limited to one poll, this content is only available for Pro users. Please go to <Link to="/settings">Settings</Link> to change your plan.</div>}
          </div>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

}


function mapStateToProps(state) { // todo: unused?
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
  }
}

export default connect(mapStateToProps, null)(ModalPoll)



// WEBPACK FOOTER //
// ./src/containers/ModalPoll.js